import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import {
  WithdrawalCustomerInfoDto,
  WithdrawalOfferDto,
} from '../../../openapi-ts';

@Injectable({
  providedIn: 'root',
})
export class WithdrawalService {
  private location = '/api/withdrawal/offer';

  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
      'api-key': 'check24at',
      'x-from-service': 'frontend-resultpage',
    }),
  };

  constructor(private http: HttpClient) {}

  public validateWithdrawal(
    c24Id: string,
    firstName: string,
    lastName: string,
    email: string,
    product: string,
  ): Observable<WithdrawalOfferDto> {
    const params = new HttpParams()
      .set('c24Id', c24Id)
      .set('firstName', firstName)
      .set('lastName', lastName)
      .set('email', email)
      .set('product', product);

    return this.http
      .get<WithdrawalOfferDto>(this.location, { ...this.httpOptions, params })
      .pipe(catchError(this.handleError<WithdrawalOfferDto>('validateWithdrawal')));
  }

  public getCustomerInfo(): Observable<WithdrawalCustomerInfoDto> {
    const url = '/api/withdrawal/customer-info';

    return this.http
      .get<WithdrawalCustomerInfoDto>(url, { ...this.httpOptions })
      .pipe(
        catchError(this.handleError<WithdrawalCustomerInfoDto>('getCustomerInfo')),
      );
  }

  public submitWithdrawal(
    offerId: string,
    transactionId: string,
  ): Observable<void> {
    const url = `/api/withdrawal/offer/${offerId}`;
    const body = { transactionId };

    return this.http
      .put<void>(url, body, this.httpOptions)
      .pipe(catchError(this.handleError<void>('submitWithdrawal')));
  }

  private handleError<T>(operation = 'operation', result?: T) {
    return (error: unknown): Observable<T> => {
      return throwError(() => error);
    };
  }
}
